module.exports = __webpack_public_path__ + "img/logo_dsc.df901335.svg";